module.exports = __webpack_public_path__ + "static/Howler.js-cbd6912aca96ba248c89ee92598a94b6.svg";